import { render } from "./ProductReviewSuccessModal.vue?vue&type=template&id=cc7c4998&scoped=true"
import script from "./ProductReviewSuccessModal.vue?vue&type=script&lang=js"
export * from "./ProductReviewSuccessModal.vue?vue&type=script&lang=js"

import "./ProductReviewSuccessModal.vue?vue&type=style&index=0&id=cc7c4998&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc7c4998"]])

export default __exports__